import './home.css';
import { useEffect,useState } from 'react';
import m1 from "../assets/images/m1.jpg";
import m2 from "../assets/images/m2.jpg";
import m3 from "../assets/images/m3.jpg";
import m5 from "../assets/images/m5.jpg";
import m6 from "../assets/images/m6.jpg";
import m7 from "../assets/images/m7.jpg";

const Work = () => {
    useEffect(() => {
    const projectItems = document.querySelectorAll('.project-right li.active');
    const projectImage = document.querySelector('.project-image');

    function handleProjectItemMouseEnter(item) {
        const imageSrc = item.getAttribute('data-image');
        projectImage.src = imageSrc;
        projectImage.style.opacity = 1;
      }
  
      function handleProjectItemMouseLeave() {
        projectImage.src = '';
        projectImage.style.opacity = 0;
      }
  
      projectItems.forEach(function (item) {
        item.addEventListener('mouseenter', () => handleProjectItemMouseEnter(item));
        item.addEventListener('mouseleave', handleProjectItemMouseLeave);
      });
      return () => {
        projectItems.forEach(function (item) {
          item.removeEventListener('mouseenter', () => handleProjectItemMouseEnter(item));
          item.removeEventListener('mouseleave', handleProjectItemMouseLeave);
        });
      };
    }, []);
    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
      }

        return (  
        <>
           <div className="noise"></div> 
    <div className="bgwork">
        <svg width="88" height="24" viewBox="0 0 88 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M38.7221 6.95427C36.6831 8.52128 34.1135 9.46191 31.5101 9.5945C28.9065 9.72709 26.4541 9.04224 24.6268 7.67216C20.716 4.72161 15.6754 2.96427 10.1794 2.63511C9.07834 2.56735 7.94574 2.68588 6.84625 2.98384C5.74677 3.28181 4.70191 3.75346 3.77137 4.3719C2.84082 4.99022 2.0428 5.7432 1.42286 6.58793C0.80293 7.43253 0.373226 8.35224 0.15827 9.29457C-0.0566738 10.2368 -0.052644 11.1833 0.170116 12.0797C0.392888 12.9762 0.830031 13.8053 1.4566 14.5195C2.08317 15.2337 2.88688 15.8191 3.82186 16.2423C4.75683 16.6656 5.80475 16.9183 6.90581 16.986C8.99836 17.111 10.9179 17.7795 12.4078 18.9019C17.1949 22.5001 23.6241 24.3019 30.4516 23.9586C37.2792 23.6155 44.0198 21.1517 49.3692 17.0439C51.4085 15.477 53.9779 14.5363 56.5815 14.4032C59.185 14.2701 61.6379 14.9542 63.4664 16.3234C67.3755 19.2762 72.416 21.0352 77.9125 21.365C80.125 21.4796 82.4083 20.8439 84.2673 19.596C86.1261 18.348 87.4104 16.5884 87.8415 14.6989C88.2727 12.8095 87.8159 10.9427 86.5702 9.5035C85.3245 8.06431 83.3906 7.16882 81.1878 7.0114C79.0947 6.88798 77.1744 6.22049 75.6841 5.09822C70.8971 1.50001 64.4679 -0.301855 57.6403 0.0413683C50.8126 0.384592 44.0715 2.84648 38.7221 6.95427Z" fill="url(#paint0_linear_131_5)"/>
            <defs>
            <linearGradient id="paint0_linear_131_5" x1="44" y1="0" x2="42.5" y2="47.5" gradientUnits="userSpaceOnUse">
            <stop stop-color="#78FFD1"/>
            <stop offset="0.309712" stop-color="#F0FFA6" stop-opacity="0.833941"/>
            <stop offset="0.732581" stop-color="#C0FFB7" stop-opacity="0.401099"/>
            <stop offset="1" stop-color="#F0FFA6" stop-opacity="0"/>
            </linearGradient>
            </defs>
        </svg>
    </div>
    <div className="main">
    <div className="header">
            <div className="left">
                <a href="/">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="icons-style">
                        <path d="M25.8073 12.7896C25.2364 12.3038 24.8659 11.6236 24.7674 10.8805C24.6689 10.1374 24.8494 9.38414 25.274 8.76637C26.1888 7.44307 26.6778 5.87193 26.6753 4.26318C26.6754 3.94077 26.6121 3.62149 26.4888 3.32357C26.3655 3.02566 26.1848 2.75494 25.9569 2.52687C25.729 2.2988 25.4584 2.11785 25.1606 1.99436C24.8628 1.87086 24.5436 1.80723 24.2212 1.8071C23.8987 1.80698 23.5795 1.87036 23.2815 1.99362C22.9836 2.11689 22.7129 2.29762 22.4848 2.52551C22.2568 2.7534 22.0758 3.02398 21.9523 3.3218C21.8288 3.61962 21.7652 3.93885 21.7651 4.26126C21.7661 4.87376 21.5802 5.472 21.2322 5.97605C20.1169 7.59498 19.6417 9.57004 19.8985 11.5191C20.1553 13.4682 21.1259 15.2527 22.6225 16.5275C23.1934 17.0134 23.5639 17.6935 23.6626 18.4366C23.7613 19.1797 23.5811 19.933 23.1568 20.551C22.2412 21.874 21.7517 23.4452 21.7539 25.0542C21.7609 25.7006 22.0226 26.3182 22.4821 26.773C22.9416 27.2277 23.5619 27.4829 24.2084 27.4832C24.8549 27.4835 25.4754 27.2289 25.9353 26.7746C26.3952 26.3202 26.6575 25.7029 26.6651 25.0564C26.6635 24.4439 26.8491 23.8455 27.197 23.3413C28.3123 21.7224 28.7876 19.7473 28.5307 17.7982C28.2739 15.8492 27.3039 14.0643 25.8073 12.7896Z" />
                        <path d="M12.3958 24.6878C13.0703 24.5928 13.6794 24.2338 14.0892 23.6897C14.499 23.1456 14.6759 22.461 14.581 21.7865C14.486 21.1121 14.127 20.5029 13.5829 20.0931C13.0388 19.6833 12.3542 19.5064 11.6797 19.6014C10.8549 19.7024 10.0234 19.4756 9.36415 18.9698C8.70486 18.4639 8.27044 17.7196 8.15437 16.8967C8.03829 16.0739 8.24982 15.2384 8.74346 14.57C9.2371 13.9015 9.97339 13.4535 10.7939 13.3224C11.1279 13.2754 11.4494 13.163 11.7399 12.9918C12.0305 12.8205 12.2845 12.5937 12.4874 12.3243C12.6903 12.0549 12.8382 11.7482 12.9225 11.4217C13.0069 11.0951 13.0261 10.7551 12.9791 10.4212C12.8841 9.74667 12.5251 9.13753 11.9811 8.72773C11.7117 8.52482 11.4049 8.37696 11.0784 8.29259C10.7518 8.20822 10.4119 8.189 10.0779 8.23601C7.89612 8.54313 5.92571 9.70438 4.60013 11.4643C3.27455 13.2242 2.70239 15.4386 3.00951 17.6204C3.31663 19.8022 4.47788 21.7726 6.23779 23.0982C7.9977 24.4237 10.2121 24.9959 12.3939 24.6888L12.3958 24.6878Z"/>
                        <path d="M29.1418 11.3626C28.8106 11.3217 28.4746 11.3464 28.1529 11.4353C27.8313 11.5243 27.5303 11.6757 27.2671 11.8809C27.004 12.0862 26.7838 12.3413 26.6193 12.6316C26.4547 12.922 26.349 13.2419 26.308 13.5731C26.2254 14.242 26.4118 14.9164 26.8264 15.4478C27.0317 15.711 27.2867 15.9311 27.5771 16.0957C27.8674 16.2602 28.1873 16.366 28.5186 16.4069C29.3327 16.5224 30.0689 16.9529 30.5688 17.6057C31.0688 18.2585 31.2925 19.0815 31.1919 19.8976C31.0913 20.7137 30.6744 21.4576 30.0309 21.9695C29.3874 22.4813 28.5687 22.7201 27.7509 22.6345C27.4197 22.5936 27.0836 22.6183 26.762 22.7072C26.4403 22.7962 26.1393 22.9476 25.8762 23.1529C25.613 23.3581 25.3929 23.6132 25.2283 23.9035C25.0638 24.1939 24.958 24.5138 24.9171 24.845C24.8344 25.5139 25.0209 26.1883 25.4354 26.7197C25.6407 26.9829 25.8958 27.203 26.1861 27.3676C26.4765 27.5321 26.7964 27.6379 27.1276 27.6788C29.2913 27.9462 31.4726 27.3431 33.1917 26.0022C34.9108 24.6613 36.0267 22.6924 36.2941 20.5286C36.5615 18.3649 35.9584 16.1836 34.6175 14.4645C33.2766 12.7455 31.3077 11.6295 29.1439 11.3621L29.1418 11.3626Z" />
                        <path d="M13.936 20.4485C14.4641 20.8044 14.8151 21.3454 14.9213 21.9669C15.0275 22.5885 14.8813 23.2465 14.5109 23.8137C13.7126 25.0293 13.3058 26.413 13.3447 27.7797C13.352 28.0536 13.4167 28.3186 13.5351 28.5594C13.6536 28.8003 13.8234 29.0123 14.035 29.1833C14.2466 29.3544 14.4958 29.4812 14.7683 29.5564C15.0409 29.6316 15.3314 29.6539 15.6234 29.6218C15.9154 29.5898 16.2031 29.5041 16.4701 29.3696C16.737 29.2352 16.9781 29.0546 17.1794 28.8382C17.3807 28.6219 17.5384 28.3739 17.6435 28.1086C17.7485 27.8432 17.7988 27.5656 17.7916 27.2917C17.7767 26.7713 17.9314 26.2445 18.235 25.7815C19.208 24.2947 19.5933 22.5692 19.3161 20.9388C19.039 19.3083 18.1192 17.8888 16.7348 16.9549C16.2067 16.599 15.8556 16.0581 15.7492 15.4365C15.6429 14.815 15.7889 14.1569 16.159 13.5895C16.958 12.3741 17.3653 10.9903 17.3265 9.62345C17.3054 9.07489 17.0543 8.57622 16.6278 8.23566C16.2013 7.8951 15.6337 7.74011 15.0482 7.80432C14.4628 7.86854 13.9066 8.14678 13.5005 8.57867C13.0944 9.01057 12.871 9.56127 12.8789 10.1113C12.8943 10.6316 12.7399 11.1586 12.4363 11.6216C11.4632 13.1084 11.078 14.8339 11.3551 16.4644C11.6323 18.0949 12.5515 19.5146 13.936 20.4485Z" />
                    </svg>
                </a>
               
                    
            </div>
            <div className="right">
               
                <div className="menu">
                    <a href="/menu">
                        <button className="hamburger-btn" aria-label="Open menu">
                            <div >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48" className="icons-style">
                                    <circle cx="12" cy="12" r="3" opacity="1" transform-origin="0px 0px" ></circle>
                                    <circle cx="24" cy="12" r="3" opacity="1" transform-origin="0px 0px" ></circle>
                                    <circle cx="36" cy="12" r="3" opacity="1" transform-origin="0px 0px" ></circle>
                                    <circle cx="36" cy="24" r="3" opacity="1" transform-origin="0px 0px"></circle>
                                    <circle cx="36" cy="36" r="3" opacity="1" transform-origin="0px 0px" ></circle>
                                    <circle cx="24" cy="36" r="3" opacity="1" transform-origin="0px 0px"></circle>
                                    <circle cx="12" cy="36" r="3" opacity="1" transform-origin="0px 0px" ></circle>
                                    <circle cx="12" cy="24" r="3" opacity="1" transform-origin="0px 0px" ></circle>
                                    <rect x="21" y="21" width="6px" height="6px" rx="3" ry="3" opacity="0.75" transform-origin="0px 0px"></rect>
                                    <rect x="21" y="21" width="6px" height="6px" rx="3" ry="3" opacity="0.75" transform-origin="0px 0px" ></rect>
                                </svg>
                            </div>
                        </button>
                    </a>
                   
                </div>
            </div>
        </div>
        <div className="projects">
            <div className="project-left"  >
                <img className="project-image" src="" alt=""/>
            </div>
            <div className="project-right">
                <ul>
                    <li  className="titleli">
                        <div className="project-title">
                           WORK
                        </div>
                        <div className="workno">
                            6
                        </div>
                    </li>
                    <li className="active work1"  data-image={m2} >
                      
                            <div className="worktitle">
                               <a href="https://github.com/Abhijeet-2003/Ad-Portal" target="_blank"> METAMASK</a> 
                            </div>
                            <div className="brief">
                                Inter IIT 
                            </div>
                      
                       
                     
                    </li>
                    <li className="active work2"  data-image={m1}  >
                  
                            <div className="worktitle">
                            <a href="https://github.com/Abhijeet-2003/DonationPortal" target="_blank"> DONATION PORTAL</a> 

                            </div>
                            <div className="brief">
                                Sail
                            </div>
                     
                    </li>
                    <li className="active work4"  data-image={m3} >
               
                            <div className="worktitle">
                            <a href="https://github.com/Abhijeet-2003/Flexi-PDF" target="_blank"> PDF CONVERTER</a> 

                            </div>
                            <div className="brief">
                                Self
                            </div>  
                        
                    </li>
                    <li className='active work5' data-image={m5}> 
                            <div className="worktitle">
                            <a href="https://github.com/Abhijeet-2003/SoundStream" target="_blank"> SOUND STREAM</a> 

                            </div>
                            <div className="brief">
                                Self
                            </div>  
                    </li>
                    <li className="active work3"  data-image={m6} >
                       
                       <div className="worktitle">
                       <a href="https://github.com/Abhijeet-2003/React-Blog" target="_blank"> React blog</a> 

                       </div>
                       <div className="brief">
                           Self
                       </div> 
                   
                
                  
               </li>
               <li className="active work3"  data-image={m7} >
                       
                       <div className="worktitle">
                       <a href="https://github.com/Abhijeet-2003/NodeJS-Blog" target="_blank"> Node.js BLOG</a> 

                       </div>
                       <div className="brief">
                           Self
                       </div> 
                   
                  
               </li>
                </ul>
              
                
            </div>
    
        </div>
        <div className="cursor-dot" ></div>
        <div className="cursor" ></div>
    </div>
        </>
    );
}
 
export default Work;